<template>
  <div
    class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid"
  >
    <div class="row">
      <div class="col">
        <h3 class="mb-3">
          {{ $t("edu_programs.edu_programs") }}
        </h3>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="/page/home">{{ $t("site.welcome") }}</a>
            </li>
            <li
              class="breadcrumb-item active"
              aria-current="page"
            >
              {{ $t("edu_programs.edu_programs") }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <!-- end of row -->

    <div class="row">
      <transition
        name="fade"
        mode="out-in"
      >
        <div
          v-if="!load"
          class="col-md-12"
        >
          <div
            v-if="eduPrograms.length"
            id="nav-group"
            class="tab-pane fade show active pt-3"
            role="tabpanel"
            aria-labelledby="nav-group-tab"
          >
            <!--begin::Container-->
            <div>
              <!--begin::Row-->
              <div
                v-for="eduProgram in eduPrograms"
                :key="eduProgram.id"
                class="card card-custom gutter-b card-stretch"
              >
                <student-card :edu-program="eduProgram" />
              </div>
            </div>
          </div>
          <!-- /.tab-pane -->
          <div
            v-else
            id="nav-group"
            class="tab-pane fade show active pt-3"
            role="tabpanel"
            aria-labelledby="nav-group-tab"
          >
            <h2>{{ $t("edu_programs.no_edu_programs") }}</h2>
          </div>
        </div>
        <div
          v-if="load"
          class="lds-ripple"
        >
          <div />
          <div />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import _studentCardVue from './components/_studentCard.vue'
import Controller from '../../../Controllers/EduProgramsController'

export default {
  name: 'EduProgramsIndexST',
  components: {
    studentCard: _studentCardVue,
  },
  data() {
    return {
      eduPrograms: {},
      load: false,
    }
  },
  async created() {
    this.load = true
    this.eduPrograms = await new Controller().MyEduPrograms()
    this.load = false
  },
  methods: {
    editItem(data) {
      this.form = true
      this.newItem = data.item
    },
  },
}
</script>

 <style   scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
